import { Typography } from '@mui/material';
import { FINPSP_DEPOSIT_CHANNELS } from '../../../constants/finpsp';
import { useFinpspDepositForm } from '../../../hooks/payment/finpsp/useFinpspDepositForm';
import useLocalization from '../../../hooks/useLocalization';
import { FormTextField } from '../../molecules/form-elements';
import StyledForm from '../shared/StyledForm';
import FinpspPaymentTypeField from './FinpspPaymentTypeField';
import type { FinpspFormProps } from './finpspForms';
import { finpspFormStyles } from './finpspFormStyles';

const FinpspDepositForm = ({ paymentProvider }: FinpspFormProps) => {
  const { t } = useLocalization();
  const { form, depositType, depositTypes, requiresPhone, isSubmitting, onSubmit } =
    useFinpspDepositForm(paymentProvider);
  const { errors } = form.formState;

  if (depositTypes.length === 0) {
    return (
      <Typography variant='body2' color='text.secondary'>
        {t('finpspDepositsUnavailable')}
      </Typography>
    );
  }

  return (
    <StyledForm
      submitTitle={t('continue')}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      disablePadding
      sx={finpspFormStyles}
    >
      <FinpspPaymentTypeField
        name='type'
        control={form.control}
        types={depositTypes}
        value={depositType}
        channels={FINPSP_DEPOSIT_CHANNELS}
        disabled={isSubmitting}
      />

      <FormTextField
        name='amount'
        control={form.control}
        label={t('finpspAmount')}
        fullWidth
        error={!!errors.amount}
        helperText={errors.amount?.message}
        disabled={isSubmitting}
        required
        slotProps={{ htmlInput: { inputMode: 'decimal' } }}
      />

      {requiresPhone && (
        <FormTextField
          name='customer_number'
          control={form.control}
          label={t('phoneNumber')}
          type='tel'
          fullWidth
          error={!!errors.customer_number}
          helperText={errors.customer_number?.message}
          disabled={isSubmitting}
          required
          slotProps={{ htmlInput: { inputMode: 'tel', autoComplete: 'tel' } }}
        />
      )}
    </StyledForm>
  );
};

export default FinpspDepositForm;
